import { render } from "./MulticoloredSpherePage.vue?vue&type=template&id=77b042b0"
import script from "./MulticoloredSpherePage.vue?vue&type=script&lang=js"
export * from "./MulticoloredSpherePage.vue?vue&type=script&lang=js"

import exportComponent from "G:\\Threejs\\VuejsThreejsForDemo-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__